import React, { useContext, useEffect, useState } from "react";
import eisalat from "../icons/9mobile.png";
import glo from "../icons/glo.png";
import airtel from "../icons/airtel.png";
import mtn from "../icons/mtn.png";
import { getOS } from "../helper/getOs";
import CurrencyFormat from "../helper/CurrencyFormat";
import { useHistory, Link } from "react-router-dom";
import { AuthContext } from "../providers/auth";
import { FormContext } from "../providers/formValues";
import { AppDataContext } from "../providers/appData";
import PlansModels from "../components/plansModels";
import NumberCheckModal from "../components/numberCheckModal";
import { UserContext } from "../providers/userData";
import PaymentType from "../components/paymentType";
import ConfirmationModel from "../components/confirmationModel";
import Layout from "../Layout";
import alert from "../icons/alert.svg";
import DisableNotification from "../components/DisableNotification";
import phonebook from "../icons/phonebook.png";
import ContactModal from "../components/ContactModal";

function PriceList() {
  const { setShowModal, showModal } = useContext(AuthContext);
  const { user } = useContext(UserContext);
  const { appData } = useContext(AppDataContext);
  const { formData, formDispatch } = useContext(FormContext);
  const [networkErro, setnetworkErro] = useState("");
  const [planerro, setPlanerro] = useState("");
  const [focused, setFocused] = useState(false);
  const [CloseNotice, setCloseNotice] = useState(false);
  const [Notice, setNotice] = useState("");
  const [sending, setSending] = useState(false);
  const airtimePlans = appData.airtime_plans || {};
  const dataPlans = appData.data_plans || {};
  const masterSettings = appData.master_settings || {};
  const getAirtimePlan = (network) => airtimePlans[network];
  const getDataPlans = (network) => dataPlans[network] || [];
  const isDataAvailable = (network) =>
    masterSettings[`${network}_data_master`] * 1 === 0 &&
    !!getAirtimePlan(network) &&
    getDataPlans(network).length > 0;
  const selectDataNetwork = (network, unavailableMessage) => {
    if (isDataAvailable(network)) {
      const plan = getAirtimePlan(network);

      onPlanSelect(network, plan.atm_price, plan.wallet_price);
      setShowModal(!showModal);
    } else {
      setCloseNotice(true);
      setShowModal(false);
    }

    setNotice(unavailableMessage);
    setnetworkErro("");
  };

  document.title = "Prices -" + appData.business.name;

  const formOnChange = (e) => {
    formDispatch({
      type: "INPUTVALUES",
      data: { name: e.target.name, value: e.target.value },
    });
  };

  const onPlanSelect = (network, atmPrice, walletPrice) => {
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "network", value: network },
    });
  };

  const history = useHistory();

  useEffect(() => {
    if (formData.fromBeneficiaries) {
      formDispatch({
        type: "INPUTVALUES",
        data: {
          name: "fromBeneficiaries",
          value: false,
        },
      });
      formDispatch({
        type: "INPUTVALUES",
        data: { name: "plans_id", value: "" },
      });
      formDispatch({
        type: "INPUTVALUES",
        data: { name: "plans_name", value: "" },
      });
      setShowModal((preShowModel) => !preShowModel);
      return;
    }
  }, []);

  return (
    <Layout PageName={"Price List"}>
      <div className="">
        <h2 className="font-medium text-sm mt-9 md:text-lg">Select Network</h2>
        {CloseNotice ? (
          <DisableNotification Close={setCloseNotice} notification={Notice} />
        ) : (
          ""
        )}
        <ContactModal />
        <div className="flex gap-4 mt-2">
          <button
            className="flex  flex-col justify-center items-center "
            onClick={() => {
              selectDataNetwork(
                "MTN",
                "MTN Data is not available now please try again later"
              );
            }}
          >
            <div
              className={
                formData.network === "MTN"
                  ? "ring-primary-orange ring-4 rounded-lg"
                  : ""
              }
            >
              {isDataAvailable("MTN") ? (
                ""
              ) : (
                <p className=" absolute  items-center justify-center rounded-full  text-white text-base">
                  <span className="relative inline-flex rounded-full h-9 w-9 bg-red-500">
                    <img src={alert} alt="alert" />
                  </span>
                </p>
              )}
              <img src={mtn} alt="mtn" className="md:h-28" />
            </div>
            <div className=" font-extrabold text-xs md:text-base mt-2.5">
              MTN
            </div>
          </button>
          <button
            className="flex  flex-col justify-center items-center"
            onClick={() => {
              selectDataNetwork(
                "GLO",
                "GLO Data is not available now please try again later"
              );
            }}
          >
            <div
              className={
                formData.network === "GLO"
                  ? "ring-primary-orange ring-4 rounded-lg"
                  : ""
              }
            >
              {isDataAvailable("GLO") ? (
                ""
              ) : (
                <p className=" absolute  items-center justify-center rounded-full  text-white text-base">
                  <span className="relative inline-flex rounded-full h-9 w-9 bg-red-500">
                    <img src={alert} alt="alert" />
                  </span>
                </p>
              )}
              <img src={glo} alt="glo" className="md:h-28" />
            </div>
            <div className=" font-extrabold text-xs md:text-base mt-2.5">
              GLO
            </div>
          </button>
          <button
            className="flex  flex-col justify-center items-center"
            onClick={() => {
              selectDataNetwork(
                "AIRTEL",
                "AIRTEL Data is not available now please try again later"
              );
            }}
          >
            <div
              className={
                formData.network === "AIRTEL"
                  ? "ring-primary-orange ring-4 rounded-lg"
                  : ""
              }
            >
              {isDataAvailable("AIRTEL") ? (
                ""
              ) : (
                <p className=" absolute  items-center justify-center rounded-full  text-white text-base">
                  <span className="relative inline-flex rounded-full h-9 w-9 bg-red-500">
                    <img src={alert} alt="alert" />
                  </span>
                </p>
              )}
              <img src={airtel} alt="airtel" className="md:h-28" />
            </div>
            <div className=" font-extrabold text-xs md:text-base mt-2.5">
              Airtel
            </div>
          </button>
          <button
            className="flex  flex-col justify-center items-center"
            onClick={() => {
              selectDataNetwork(
                "ETISALAT",
                "9mobile Data is not available now please try again later"
              );
            }}
          >
            <div
              className={
                formData.network === "ETISALAT"
                  ? "ring-primary-orange ring-4 rounded-lg"
                  : ""
              }
            >
              {isDataAvailable("ETISALAT") ? (
                ""
              ) : (
                <p className=" absolute  items-center justify-center rounded-full  text-white text-base">
                  <span className="relative inline-flex rounded-full h-9 w-9 bg-red-500">
                    <img src={alert} alt="alert" />
                  </span>
                </p>
              )}
              <img src={eisalat} alt="etisalat" className="md:h-28" />
            </div>
            <div className=" font-extrabold text-xs md:text-base mt-2.5">
              9mobile
            </div>
          </button>
        </div>
        <p className="text-red-500">{networkErro}</p>
      </div>
    </Layout>
  );
}

export default PriceList;
